import { useQuery } from "@tanstack/react-query";
import { listLoras } from "../../services/lorasApi";
import { loraQueryKeys } from "./queryKeys";
import type { ListLorasFilters } from "../../types/loras";

/**
 * List LoRAs visible to the caller (user_private owned by caller +
 * team_shared across the caller's active teams). Server-side paginated;
 * `filters` map directly to the `/v1/loras` query string.
 */
export function useLoras(filters?: ListLorasFilters) {
  return useQuery({
    queryKey: loraQueryKeys.list(filters),
    queryFn: () => listLoras(filters),
    staleTime: 30_000,
  });
}
